import React from "react";
import { Button, Select, SelectItem, SelectionMode } from "@heroui/react";

export interface Item {
  key: string;
  value: string;
}

interface ColorFilterProps {
  onFilter: (selectedItems: Set<string>) => void;
}

export default function GenericFilter({
  selected,
  setSelected,
  data,
  label,
  selectionMode,
  classNames,
  startContent,
  color = "default",
  triggerClassNames = "",
  disallowEmptySelection = false,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
  data: Item[];
  label: string;
  selectionMode: SelectionMode;
  classNames?: string | undefined;
  triggerClassNames?: string;
  startContent?: any;
  color?: string;
  disallowEmptySelection?: boolean;
}) {
  const handleSelectionChange = (selectedKeys: any) => {
    // Convert Selection to an array of strings
    const selectedItems = Array.from(selectedKeys).map((key) => key as string);
    const newSelection = new Set(selectedItems);
    setSelected(newSelection);
  };
  const handleReset = () => {
    setSelected(new Set());
  };

  return (
    <div>
      <Select
        size={"sm"}
        // label={label}
        color={color as any}
        placeholder={label}
        aria-label={label}
        selectedKeys={Array.from(selected)}
        selectionMode={selectionMode}
        className={`w-[150px] ${classNames} min-h-0`}
        classNames={{
          trigger: `min-h-0 h-[32px] ${triggerClassNames}`,
        }}
        startContent={startContent}
        onSelectionChange={handleSelectionChange}
        disallowEmptySelection={disallowEmptySelection}
      >
        {data.map((item) => (
          <SelectItem key={item.key}>{item.value}</SelectItem>
        ))}
      </Select>
      {/* <Button color="primary" onClick={handleReset}>
                Reset
            </Button> */}
      {/* <p className="text-small text-default-500">Selected: {Array.from(selected).join(', ')}</p> */}
    </div>
  );
}
